module.exports = __webpack_public_path__ + "static/media/faccia_11.ba96ed0b.png";